import { useState } from "react";
import { FaEdit, FaCheck, FaTrash } from "react-icons/fa";

const CategoryTable = ({ categories, onSave, onDelete }) => {
  const [editingCategory, setEditingCategory] = useState(null);
  const [newCategory, setNewCategory] = useState("");

  const handleEdit = (category) => {
    setEditingCategory(category);
    setNewCategory(category);
  };

  const handleSave = () => {
    onSave(editingCategory, newCategory);
    setEditingCategory(null);
    setNewCategory("");
  };

  if (categories.length === 0) {
    return (
      <div className="text-center py-4 text-gray-400 text-sm">
        No categories yet
      </div>
    );
  }

  return (
    <div className="space-y-2">
      {categories.map((category) => (
        <div
          key={category}
          className={`flex items-center justify-between p-3 rounded-xl transition-all ${
            editingCategory === category
              ? "bg-gray-100 border border-gray-300"
              : "bg-gray-50 hover:bg-gray-100"
          }`}
        >
          {editingCategory === category ? (
            <>
              <input
                type="text"
                value={newCategory}
                onChange={(e) => setNewCategory(e.target.value)}
                className="flex-1 p-2 bg-white border border-gray-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-gray-400 focus:border-transparent"
                autoFocus
              />
              <div className="flex gap-1 ml-2">
                <button
                  onClick={handleSave}
                  className="p-2 rounded-lg text-emerald-600 hover:bg-emerald-50 transition-colors"
                >
                  <FaCheck size={14} />
                </button>
                <button
                  onClick={() => onDelete(category)}
                  className="p-2 rounded-lg text-red-500 hover:bg-red-50 transition-colors"
                >
                  <FaTrash size={14} />
                </button>
              </div>
            </>
          ) : (
            <>
              <span className="text-sm font-medium text-gray-700">{category}</span>
              <button
                onClick={() => handleEdit(category)}
                className="p-2 rounded-lg text-gray-400 hover:text-gray-600 hover:bg-gray-200 transition-all"
              >
                <FaEdit size={14} />
              </button>
            </>
          )}
        </div>
      ))}
    </div>
  );
};

export default CategoryTable;
